import React, {useEffect} from "react";
import {connect} from "react-redux";

import {markUpDownContextAction, useMarkUpContext} from "./FeaturesSetupMarkUpContext";
import FeaturesSetupMarkPopupListItem from "./FeaturesSetupMarkPopupListItem";
import {getFilteredFeatures} from "../featuresFunctions";
import {createMarkUpList} from "./markUpFunctions";

const FeaturesSetupMarkPopupList = (props) => {

  const {featuresList} = props;

  const {markUpDownContextState, markUpDownContextDispatch} = useMarkUpContext();
  const {markUpList} = markUpDownContextState;

  useEffect(() => {
    markUpDownContextDispatch(markUpDownContextAction({
      markUpList: createMarkUpList(featuresList),
    }))
  }, [])

  // const currentMarkUpList = markUpList.filter(markUpItem => applyToValue === markUpItem.applyTo);
  if (!markUpList.length) {
    return <ul className="ui-mark-list"/>
  }

  return (
    <ul className="ui-mark-list">
      {markUpList.map((markUpListItem, markUpListItemIndex) => (
        <FeaturesSetupMarkPopupListItem key={(markUpListItem.updated || markUpListItem.created) + markUpListItemIndex}
                                        featuresList={featuresList}
                                        markUpListItemIndex={markUpListItemIndex}
                                        markUpListItem={markUpListItem}/>
      ))}
    </ul>
  )
};

const mapStateToProps = (store) => {
  const featuresList = getFilteredFeatures(store, false, true);

  return {
    featuresList,
  };
};

// const mapDispatchToProps = {
// };

export default connect(mapStateToProps)(FeaturesSetupMarkPopupList)
